import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation Delete($id: Int!) {
    deleteForm(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteForm: {
    id?: number;
  };
}
